<template>
  <div v-if="isMounted">
    <!-- <vx-card> -->
    <div class="vx-row" v-if="!showNewAccountForm">
      <div class="vx-col w-full md:w-2/3">
        <h4>Tus cuentas de banco.</h4>
        <div>
          <!-- <p class="mb-2 mt-2">
              <span class="bold">¡No olvides tener a la mano tu Segundo Factor de Autenticación!</span>
            </p> -->
          <p class="mb-2 mt-base">
            Consulta y administra tus cuentas aquí.<br><br>
            Para registrar una cuenta nacional debes realizar un abono desde esa cuenta.<br><br>
            También puedes registrar una cuenta bancaria internacional. Consulta la <a href="#" class="underline black"
              @click="goToGafiBlog()">lista</a> de
            países con restricciones.
          </p>
          <!-- tabla de cuentas de banco -->
          <div class="vx-row mt-6 mb-2">
            <div class="vx-col xxl:w-2/3 lg:w-full w-full">
              <div class="data-list-container data-list-list-view data-list-rows vs-con-loading__container"
                id="main-div">
                <vs-table class="mt-1" ref="accountsTable" :data="formattedAccounts"
                  noDataText="No hay cuentas registradas">
                  <template slot="thead">
                    <vs-th class="bold">Banco</vs-th>
                    <vs-th class="bold">SWIFT / BIC / IBAN / ABA</vs-th>
                    <!-- <vs-th class="bold">Estado</vs-th> -->
                    <vs-th class="bold">Acciones</vs-th>
                  </template>

                  <template slot-scope="{data}">
                    <tbody>
                      <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data"
                        :state="isAccountSelected(tr) ? 'black' : null">
                        <vs-td>
                          {{ tr.bank_name }}
                        </vs-td>
                        <vs-td>
                          <div class="flex">
                            <vx-tooltip :text="tr.status_name">
                              <span :class="bankAccountColor(tr.status) + ' mt-1'"></span>
                            </vx-tooltip>
                            <span class="ml-5">{{ tr.clabe }}</span>
                          </div>
                        </vs-td>
                        <!-- <vs-td>
                          {{ tr.status_name }}
                        </vs-td> -->
                        <!--vs-td>
                          <span v-if="!isAccountSelected(tr) && isSelectable(tr) && isVerified(tr)" class="text-sm text-primary">
                            Seleccionar
                          </span>
                        </vs-td-->
                        <vs-td>
                          <div class="flex items-center flex-grow flex-no-wrap w-full">
                            <feather-icon icon="StarIcon" :svgClasses="getSelectIconClass(tr)"
                              @click.stop="selectAccountRequest(tr)" />
                            <feather-icon icon="Trash2Icon" :svgClasses="klassFull" class="ml-5"
                              @click.stop="deleteAccountRequest(tr)" />
                          </div>
                        </vs-td>
                      </vs-tr>
                    </tbody>
                  </template>
                </vs-table>
              </div>
            </div>
          </div>
          <!-- fin tabla de cuentas de banco -->
        </div>
        <div v-if="bankOrigin == bankOriginForeign || bankOrigin == bankOriginBoth" class="vx-row mt-6 mb-2">
          <div class="vx-col w-full mt-5">
            <vs-button class="px-3" @click="showNewAccountForm = true">Agregar cuenta internacional</vs-button>
          </div>
        </div>
      </div>
    </div>
    <!-- </vx-card> -->

    <div class="vx-row" v-else>
      <div class="vx-col w-full xl:w-1/2">
        <p class="bold mb-5">
          Ingresa los datos de tu cuenta bancaria para poder subir un documento donde podamos consultar de manera clara
          y
          legible la misma cuenta que ingresaste.
        </p>
        <div class="vx-row">
          <div :class="colClass">
            <label class="vs-input--label">País *</label>
            <v-select class="vs-custom" name="bankCountry" :class="{
              'has-error': hasError('bankCountry'),
              'is-success': isSuccess('bankCountry'),
            }" v-model.lazy="bankCountry" v-validate="requiredRules" :options="collections.foreign_countries"
              :reduce="(item) => item.value" :clearable="false" placeholder="Selecciona una opción" :searchable="false">
            </v-select>
            <v-error v-if="hasError('bankCountry')" :error="errorText('bankCountry')" />
          </div>
          <div :class="colClass">
            <label class="vs-input--label">Divisa *</label>
            <v-select class="vs-custom" name="bankCurrency" :class="{
              'has-error': hasError('bankCurrency'),
              'is-success': isSuccess('bankCurrency'),
            }" v-model.lazy="bankCurrency" v-validate="requiredRules" :options="collections.currencies"
              :reduce="(item) => item.value" :clearable="false" placeholder="Selecciona una opción" :searchable="false">
            </v-select>
            <v-error v-if="hasError('bankCurrency')" :error="errorText('bankCurrency')" />
          </div>
        </div>
        <div class="vx-row">
          <div :class="colClassFull">
            <label class="vs-input--label">Nombre del banco *</label>
            <vx-textarea class="w-full" v-model.lazy="bankName" name="bankName" v-validate="requiredRules"
              :danger="hasError('bankName')" :danger-text="errorText('bankName')" :success="isSuccess('bankName')"
              :placeholder="requiredPlaceholder" height="50px" maxlength="255" />
          </div>
          <div :class="colClassFull">
            <label class="vs-input--label">Domicilio del banco *</label>
            <vx-textarea class="w-full" v-model.lazy="bankAddress" name="bankAddress" v-validate="requiredRules"
              :danger="hasError('bankAddress')" :danger-text="errorText('bankAddress')"
              :success="isSuccess('bankAddress')" :placeholder="requiredPlaceholder" height="100px" maxlength="255" />
          </div>
          <div :class="colClassFull" v-if="showAnotherInternationalBankReasonInput">
            <label class="vs-input--label">¿Cuál es el motivo por el que indicas un país o jurisdicción distinta a la(s)
              cuenta(s) de banco que ya tienes registrada(s)? *</label>
            <vx-textarea class="w-full" v-model.lazy="anotherInternationalBankReason"
              name="anotherInternationalBankReason" v-validate="requiredRules"
              :danger="hasError('anotherInternationalBankReason')"
              :danger-text="errorText('anotherInternationalBankReason')"
              :success="isSuccess('anotherInternationalBankReason')" :placeholder="requiredPlaceholder" height="100px"
              maxlength="255" />
          </div>
        </div>
        <div class="vx-row">
          <div :class="colClass">
            <label class="vs-input--label">Tipo de código *</label>
            <v-select class="vs-custom" name="bankCodeType" :class="{
              'has-error': hasError('bankCodeType'),
              'is-success': isSuccess('bankCodeType'),
            }" v-model.lazy="bankCodeType" v-validate="requiredRules" :options="collections.bank_code_types"
              :reduce="(item) => item.value" :clearable="false" placeholder="Selecciona una opción" :searchable="false">
            </v-select>
            <small v-if="bankCodeType == 'iban'">El IBAN aplica para 69 paises principalmente de la unión
              europea.</small>
            <small v-if="bankCodeType == 'aba'">El routing number aplica principalmente para Estados Unidos.</small>
            <v-error v-if="hasError('bankCodeType')" :error="errorText('bankCodeType')" />
          </div>
          <div :class="colClass">
            <vs-input class="w-full" label="Código *" name="bankCode" v-validate="requiredRules" v-model.lazy="bankCode"
              :danger="hasError('bankCode')" :danger-text="errorText('bankCode')" :success="isSuccess('bankCode')"
              icon-pack="feather" :placeholder="requiredPlaceholder" />
            <small v-if="bankCodeType == 'iban'">Ingresa entre 0 y 34 caracteres.</small>
            <small v-if="bankCodeType == 'aba'">Ingresa 9 caracteres.</small>
            <small v-if="bankCodeType == 'swift'">Ingresa entre 8 y 11 caracteres.</small>
          </div>
        </div>
        <div class="vx-row">
          <div :class="colClass">
            <vs-input class="w-full" label="Número de cuenta" name="bankAccountNumber" v-model.lazy="bankAccountNumber"
              :danger="hasError('bankAccountNumber')" :danger-text="errorText('bankAccountNumber')"
              :success="isSuccess('bankAccountNumber')" icon-pack="feather" placeholder="(Opcional)" />
          </div>
        </div>
        <div class="vx-row">
          <div :class="colClassFull">
            <document-upload-lite :accepts="['pdf', 'png', 'jpg', 'jpeg']" name="Caratula Estado de Cuenta"
              check-url="/" view-url="/" download-url="/" :upload-url="uploadUrl" width="1/2"
              :canUpload="createdAccountId" @on-success="onSuccessEvent" />
          </div>
        </div>
        <vs-alert v-if="errorMssg" icon-pack="feather" icon="icon-alert-triangle" class="mb-5" color="danger">
          <span class="font-regular">{{ errorMssg }}</span>
        </vs-alert>
        <div class="vx-row">
          <div class="vx-col xl:w-1/2 md:w-1/2 w-full">
            <div v-if="!createdAccountId" class="flex items-center flex-grow flex-no-wrap w-full">
              <vs-button class="w-full mt-4 mr-5" color="dark" v-if="!onlyForm"
                @click="showNewAccountForm = false">Cancelar</vs-button>
              <vs-button class="w-full mt-4" @click="saveDataForm">Registrar</vs-button>
            </div>
            <!-- <vs-button v-else class="w-full mt-4" @click="finishProcess">Finalizar</vs-button> -->
          </div>
        </div>
      </div>
    </div>

    <!-- Componente para segundo factor -->
    <two-factor-auth :user-id="UserId"
      custom-indication-message="Por favor ingresa los 6 dígitos de tu Segundo Factor de Autenticación para ejecutar la operación."
      @on-code-validated="onAuth" />
  </div>
</template>

<script>
import auth2faHelper from "@mixins/auth2faHelper";
import TwoFactorAuth from "@components/2fa/TwoFactorAuth";
import { BankAccountStatus } from "@/bl/BankAccountStatus";
import BankOriginEnum from "@/modules/enums/BankOriginEnum";
import { mapState } from "vuex";
import DocumentUploadLite from "@components/upload/DocumentUploadLite";

export default {
  name: "InternationalBankAccounts",
  components: {

    TwoFactorAuth,
    DocumentUploadLite
  },
  mixins: [auth2faHelper, BankOriginEnum],
  props: {
    isMoral: { type: Boolean, required: true },
    userId: { type: [String, Number], required: true },
    personType: { type: [String, Number], required: true },
    hasBackofficeAccess: { type: Boolean, required: true },
    userData: { type: Object, required: true },
    onlyForm: { type: Boolean, default: false },
  },
  data() {
    return {
      isMounted: false,
      bankOriginMexico: BankOriginEnum.MEXICO,
      bankOriginBoth: BankOriginEnum.AMBAS,
      bankOriginForeign: BankOriginEnum.EXTRANJERO,
      userAccounts: [],
      validAccountsCountries: [],
      formattedAccounts: [],
      accountIdSelected: null,
      accountIdToDelete: null,
      createdAccountId: null,
      klassBase: "h-5 w-5 stroke-current",
      klassFull: "h-5 w-5 stroke-current hover:text-primary cursor-pointer",
      collections: {
        foreign_countries: [],
        currencies: [],
        bank_code_types: [
          { "value": "swift", "label": "SWIFT/BIC" },
          { "value": "aba", "label": "ABA" },
          { "value": "iban", "label": "IBAN" }
        ]
      },
      showNewAccountForm: this.onlyForm,
      mexicoCountryId: 700,
      onError: false,
      errorMssg: null,
      currentIdForSelection: null,
      currentIdToDelete: null,
      factorEnabled: false,
      currentAuthAction: null,
      requiredRules: "required",
      errorMssg: null,
      colClass: "vx-col lg:w-1/2 w-full mb-5",
      colClassFull: "vx-col w-full mb-5",
      requiredPlaceholder: "(Requerido)",
      bankCountry: null,
      bankCurrency: null,
      bankName: null,
      bankAddress: null,
      anotherInternationalBankReason: null,
      bankAccountNumber: null,
      bankCodeType: null,
      bankCode: null
    }
  },
  created() {
    this.AUTH_ACTION_SELECT_ACCOUNT = 1;
    this.AUTH_ACTION_DELETE_ACCOUNT = 2;
    this.AUTH_ACTION_SAVE_ACCOUNT = 3;
  },
  async mounted() {
    await this.setInitialState();
  },
  computed: {
    ...mapState("auth", ["roleGeneralData"]),
    bankOrigin() {
      return this.roleGeneralData.bank_origin;
    },
    uploadUrl() {
      return this.createdAccountId
        ? `investor/bank-accounts/${this.createdAccountId}/upload`
        : "/";
    },
    showAnotherInternationalBankReasonInput() {
      return (
        this.validAccountsCountries.length > 0 &&
        this.bankCountry &&
        !this.validAccountsCountries.includes(this.bankCountry)
      );
    },
  },
  methods: {
    async refreshAccounts() {
      await this.getUserAccounts();
    },
    async onFinish() {
      await this.$router.go();
    },
    getSelectIconClass(tr) {
      let klass = this.klassBase;
      if (this.isAccountSelected(tr)) {
        klass += " fill-current text-primary";
      }
      else {
        if (this.isSelectable(tr)) {
          klass += " hover:text-primary cursor-pointer";
        }
        else {
          klass += " opacity-30";
        }
      }
      return klass;
    },
    async getUserAccounts() {
      try {
        const res = await axios.get('api/app/bank-account');
        const accs = res.data;
        this.userAccounts = accs;
        this.formattedAccounts = [];
        let validCountries = [];
        accs.forEach(f => {
          let nacc = this.getFormattedAccount(f);
          this.formattedAccounts.push(nacc);
          if (nacc.is_verified) {
            validCountries.push(f.bank.country_id);
          }
        });
        let setValidCountries = new Set(validCountries);
        this.validAccountsCountries = [...setValidCountries];
        this.formattedAccounts.sort(function (a, b) {
          if (a.is_default) {
            return -1
          }
          else if (b.is_default) {
            return 1;
          }
          else if (a.is_verified && b.is_verified) {
            return a.clabe > b.clabe;
          }
          else if (a.is_verified && !b.is_verified) {
            return -1
          }
          else if (!a.is_verified && b.is_verified) {
            return 1
          }
          return 0;
        });
      }
      catch (e) {
      }
    },
    getFormattedAccount(f) {
      let nacc = {
        id: f.id,
        bank_id: f.bank_id,
        is_default: f.is_default === 1,
        is_verified: f.verified === BankAccountStatus.VERIFIED,
        status: f.verified,
        status_name: BankAccountStatus.getAccountStatusName(f.verified),
      }

      nacc.bank_name = f.bank.name;

      if (f.bic_swift) {
        nacc.clabe = f.bic_swift;
      }
      else {
        if (f.iban) {
          nacc.clabe = f.iban;
        } else {
          nacc.clabe = f.routing_number;
        }
      }
      return nacc;
    },
    async setInitialState() {
      this.isMounted = false;
      this.bankCountry = null;
      this.bankCurrency = null;
      this.bankName = null;
      this.bankAddress = null;
      this.anotherInternationalBankReason = null;
      this.bankAccountNumber = null;
      this.bankCodeType = null;
      this.bankCode = null;
      this.createdAccountId = null;
      this.showLoading(true)
      await this.getCollections();
      await this.getUserAccounts();
      this.factorEnabled = await this.getUser2FAStatus(this.UserId);
      this.setDefaults();
      this.showLoading(false);
      this.isMounted = true;
    },
    setDefaults() {
      let account = this.formattedAccounts.find(f => f.is_default);
      if (account != null) {
        this.accountIdSelected = account.id;
      }
    },
    async getCollections() {
      try {
        let collectionsObjects = ['foreignCountriesList', 'currencies'];
        let params = "with[]=" + collectionsObjects.join("&with[]=");
        let res = await this.publicApiGet(`/api/v1/forms/getPublicFormCollections?${params}`);
        let colls = res.data;
        colls.foreignCountriesList.forEach(opt => {
          if (opt.gafi != "black" && opt.gafi != "gray") {
            this.collections.foreign_countries.push({ value: parseInt(opt.id), label: opt.name });
          }
        })
        colls.currencies.forEach(opt => {
          this.collections.currencies.push({ value: parseInt(opt.id), label: opt.short_name });
        })
      }
      catch (e) {
      }
    },
    async saveDataForm() {
      this.errorMssg = null;
      if (!(await this.validateForm())) {
        return;
      }
      let maxInputLenght = 0;
      let minInputLenght = 1;
      switch (this.bankCodeType) {
        case "iban":
          maxInputLenght = 34;
          break;
        case "aba":
          minInputLenght = 9;
          maxInputLenght = 9;
          break;
        case "swift":
          maxInputLenght = 11;
          minInputLenght = 8;
          break;
        default:
          break;
      }
      if (this.bankCode.length < minInputLenght || this.bankCode.length > maxInputLenght) {
        this.errorMssg = "El número de caracteres del codigo no es válido.";
        return;
      }
      this.showLoading(true, "Guardando información...");
      try {
        let payload = {
          bank_country: this.bankCountry,
          bank_currency: this.bankCurrency,
          bank_name: this.bankName,
          bank_address: this.bankAddress,
          another_international_bank_reason: this.anotherInternationalBankReason,
          bank_code_type: this.bankCodeType,
          bank_code: this.bankCode,
          bank_account_number: this.bankAccountNumber
        };
        const res = await axios.post(
          "/api/v2/investor/create-bank-account",
          payload
        );
        this.successNotifDialog('Cuenta registrada', 'Ahora sube el estado de cuenta para finalizar');
        this.createdAccountId = res.data.bank_account_id;
        this.showLoading(false);
        this.$emit("updated", 1);
      } catch (e) {
        this.showLoading(false);
        this.showError(e);
      }
    },
    showError(e) {
      this.warn(e);
      let err = "Ha ocurrido un error con la operación, intente más tarde";
      if (e.response && e.response.data && e.response.data.error) {
        err = e.response.data.error;
      }
      this.errorMssg = err;
    },
    async validateForm() {
      this.errorMssg = null;
      return this.$validator.validateAll();
    },
    async onSuccessEvent(res) {
      this.showNewAccountForm = false;
      this.successNotif("Cuenta registrada", "Tu cuenta ha sido registrada exitosamente", 8000);
      if (this.onlyForm) {
        this.$router.go();
      } else {
        await this.setInitialState();
      }
    },
    async selectAccountRequest(tr) {
      if (tr.id === this.accountIdSelected) {
        return;
      }
      if (!this.isVerified(tr)) {
        this.warningNotifDialog('Cuenta no verificada', 'No se puede marcar esta cuenta como predeterminada ya que aún no ha sido verificada.');
      }
      else {
        if (!this.checkForFactorEnabled()) {
          return;
        }
        this.currentIdForSelection = tr.id;
        let mssg = "Al seleccionarla esta será la cuenta en la que recibirás tus fondos al retirar de tu cuenta de RedGirasol. Podrás cambiarla cuando tu desees en esta misma sección.";
        this.confirmationDialog(this.requestAuthSelectAccount, "¿Estás seguro que deseas que esta sea tu cuenta predeterminada?", mssg, "Confirmar");
      }
    },
    async requestAuthSelectAccount() {
      this.currentAuthAction = this.AUTH_ACTION_SELECT_ACCOUNT;
      this.requestAuth();
    },
    async requestAuthDeleteAccount() {
      this.currentAuthAction = this.AUTH_ACTION_DELETE_ACCOUNT;
      this.requestAuth();
    },
    async requestAuthSaveAccount() {
      this.currentAuthAction = this.AUTH_ACTION_SAVE_ACCOUNT;
      this.requestAuth();
    },
    async onAuth(code) {
      switch (this.currentAuthAction) {
        case this.AUTH_ACTION_SELECT_ACCOUNT:
          await this.doSelectAccount(code);
          break;
        case this.AUTH_ACTION_DELETE_ACCOUNT:
          await this.doDeleteAccount(code);
          break;
        case this.AUTH_ACTION_SAVE_ACCOUNT:
          await this.$refs.formBankAccount.doSaveChanges(code);
          break;
      }
    },
    requestAuth() {
      this.$store.commit("TOGGLE_IS_2FA_POPUP_ACTIVE", true);
    },
    async doSelectAccount(code) {
      this.showLoading(true)
      try {
        let payload = { bank_account_id: this.currentIdForSelection, code: code };
        this.injectAccountMetadataToPayload(payload);
        await axios.put(`api/app/bank-account/${this.currentIdForSelection}/change-as-favorite`, payload);
        this.successNotif("Preferencias actualizadas", "Tu cuenta predeterminada ha sido actualizada", 8000);
        await this.getUserAccounts();
        this.setDefaults();
      }
      catch (e) {
        this.failedOperationNotif();
      }
      this.showLoading(false)
    },
    async deleteAccountRequest(tr) {
      if (!this.checkForFactorEnabled()) {
        return;
      }
      if (this.formattedAccounts.length > 1) {
        this.currentIdToDelete = tr.id;
        let verifiedCount = this.formattedAccounts.filter(f => f.is_verified).length;

        if (tr.is_verified) {
          if (verifiedCount === 1) {
            // no se puede eliminar si es la unica
            let mssg = "Para eliminarla será necesario agregar una nueva abonando fondos a tu cuenta de RedGirasol. Recuerda que debes tener al menos una cuenta de banco registrada.";
            this.cannotDeleteMssg(mssg);
          }
          else {
            let mssg = "Recuerda que para registrarla nuevamente deberás abonar fondos a través de una transferencia desde tu banca en línea. " +
              "Este proceso no podrá revertirse una vez eliminada.";
            this.confirmDeletion(mssg);
          }
        }
        else {
          let mssg = "Recuerda que para registrarla nuevamente deberás abonar fondos a través de una transferencia desde tu banca en línea. " +
            "Este proceso no podrá revertirse una vez eliminada.";
          this.confirmDeletion(mssg);
        }
      }
      else {
        let mssg = "Para eliminarla será necesario agregar una nueva abonando fondos a tu cuenta de RedGirasol. Recuerda que debes tener al menos una cuenta de banco registrada.";
        this.cannotDeleteMssg(mssg);
      }
    },
    async doDeleteAccount(code) {
      this.showLoading(true)
      try {
        let payload = { bank_account_id: this.currentIdToDelete, code: code };
        this.injectAccountMetadataToPayload(payload);
        await axios.delete(`api/app/bank-account/${this.currentIdToDelete}/delete`, payload);
        this.successNotif("Cuenta eliminada", "La cuenta ha sido eliminada exitosamente", 8000);
        await this.getUserAccounts();
        this.setDefaults();
      }
      catch (e) {
        if (e && e.response && e.response.data && e.response.data.error) {
          this.errorNotifDialog("No ha sido posible eliminar la cuenta bancaria", e.response.data.error);
        }
        else {
          this.failedOperationNotif();
        }
      }
      this.showLoading(false)
    },
    confirmDeletion(mssg) {
      this.confirmationDialog(this.requestAuthDeleteAccount, "¿Estás seguro que deseas eliminar esta cuenta?", mssg, "Eliminar", "Cancelar");
    },
    cannotDeleteMssg(mssg) {
      this.confirmationDialog(this.goToPayFunds, "No es posible eliminar esta cuenta", mssg, "Abonar fondos", "Cancelar");
    },
    checkForFactorEnabled() {
      if (!this.factorEnabled) {
        this.$vs.dialog({
          color: "warning",
          type: "confirm",
          title: "Autenticación necesaria",
          text: "Para realizar esta operación es necesario habilitar tu Segundo Factor de Autenticación.",
          acceptText: "Habilitar",
          cancelText: 'Cancelar',
          accept: this.goTo2FaPage,
        });
        return false;
      }
      return true;
    },
    async goTo2FaPage() {
      await this.$router.push({ name: 'auth2FaInversionista' });
    },
    isAccountSelected(tr) {
      return tr.id === this.accountIdSelected;
    },
    isSelectable(tr) {
      return tr.is_verified;
    },
    isVerified(tr) {
      return tr.is_verified;
    },
    clean() {
      this.onError = false
      this.errorMssg = null
    },
    async goToPayFunds() {
      await this.$router.push({ name: 'abonarFondos' });
    },
    hasError(val) {
      return this.errors.has(val);
    },
    errorText(val) {
      return this.errors.first(val);
    },
    isSuccess(val) {
      let ff = this.fields[val];
      return ff && ff.required && ff.valid;
    },
    goToGafiBlog() {
      window.open("https://soporte.redgirasol.com/support/solutions/articles/48001264004-pa%C3%ADses-restringidos-para-realizar-transacciones", "_blank");
    },
    // funcion para el semaforo de las cuentas bancarias
    bankAccountColor(status) {
      let dotClass = "dot-gray";
      switch (status) {
        case 'verified':
          dotClass = 'dot-green';
          break;
        case 'verified_requested':
          dotClass = 'dot-yellow';
          break;
        case 'unverified':
          dotClass = 'dot-gray';
          break;
        case 'rejected':
          dotClass = 'dot-red';
          break;
        default:
          break;
      }
      return dotClass;
    },
  }
}
</script>

<style scoped></style>